import { Link } from "react-router-dom";

export default function AppLogo({
  to = "/",
  subtitle = "",
  size = 40,
  onClick,
}) {
  return (
    <Link
      to={to}
      onClick={onClick}
      className="flex items-center gap-3 hover:opacity-90 transition-opacity"
    >
      <img
        src="/medibooks-logo.png"
        alt="MediBooks"
        style={{ width: size, height: size }}
        className="rounded-xl object-cover"
      />

      <div>
        <div className="text-sm font-semibold tracking-wide">
          MediBooks
        </div>

        {subtitle && (
          <div className="text-[10px] uppercase tracking-[0.25em] text-mb-fg2">
            {subtitle}
          </div>
        )}
      </div>
    </Link>
  );
}